// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__38l2c","footer":"Form_footer__288Hn"};